import { SectionHeader } from "../SharedComponents";
import * as React from "react";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TaxResidency } from "./TaxResidency";
import { Nationality } from "./Nationality";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import {
    EmploymentRole,
    IndividualEmploymentStatusOptions,
    IndividualEmploymentStatusOptionsMap,
} from "../../../NewQuoteWizard/Resource/Content";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../Resource/EWizardLinterHelper";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { isEmpty } from "lodash";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { OccupationIndustry } from "../../../ClientRecord/Resource/Contents";
import { SourceOfWealth } from "./SourceOfWealth";

interface ITaxDetailProps extends IProcessComponentProps {
    onCCMChange: (changes) => void;
    data: FullClientDetailModel;
    disableWhenFullClient: boolean;
    isAddNewProduct?: boolean;
    existingClientInfo?: FullClientDetailModel;
    disableHeader?: boolean;
    existingCustomer?:boolean;
}

interface ITaxDetailState {
    disableTax: boolean;
    taxResidencyOtherThanUK: boolean;
    residencies: CustomerTaxResidencyModel[];
    nationalities: CustomerTaxResidencyModel[];
}

export class TaxDetail extends ProcessComponent<ITaxDetailProps, ITaxDetailState> {
    constructor(props: ITaxDetailProps) {
        super(props);
        this.state = {
            disableTax: false,
            taxResidencyOtherThanUK: props?.data?.CustomerTaxResidencyDetails?.some(
                (x) => x?.Country !== CountryCode.GBR && x?.IsTaxResident == true
            ),
            residencies: props.data.CustomerTaxResidencyDetails.filter((entry) => {
                return entry.IsTaxResident;
            }).map(
                (entry): CustomerTaxResidencyModel => {
                    return {
                        Country: entry.Country,
                        IsTaxResident: entry.IsTaxResident,
                        PrimaryTaxResidency: entry.PrimaryTaxResidency,
                        TaxReferenceType: entry.TaxReferenceType,
                        TaxReference: entry.TaxReference,
                        TaxResidencyForPensionRelief: entry.TaxResidencyForPensionRelief,
                        TaxExempt: entry.TaxExempt,
                        TaxExemptionReason: entry.TaxExemptionReason,
                    };
                }
            ),
            nationalities: props.data.CustomerTaxResidencyDetails.filter((entry) => {
                return entry.IsNationality;
            }).map(
                (entry): CustomerTaxResidencyModel => {
                    return {
                        Country: entry.Country,
                        PrimaryCitizenship: entry.PrimaryCitizenship,
                        NationalIdentifier: entry.NationalIdentifier,
                        PassportNumber: entry.PassportNumber,
                        TaxExempt: entry.TaxExempt,
                        TaxExemptionReason: entry.TaxExemptionReason,
                        IsNationality: entry.IsNationality,
                        TaxReference: entry.TaxReference,
                    };
                }
            ),
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.checkDisableStatus();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.data?.ActorId !== this.props.data?.ActorId && this.props.disableWhenFullClient == true) {
            this.checkDisableStatus();
        }

        if (
            this.props.data.CustomerTaxResidencyDetails.length > 0 ||
            prevProps.data?.ActorId !== this.props.data?.ActorId
        ) {
            const { CustomerTaxResidencyDetails } = this.props.data;
            if (
                this.props.data?.CustomerTaxResidencyDetails?.length !=
                prevProps.data?.CustomerTaxResidencyDetails?.length
            ) {
                const nationalities = CustomerTaxResidencyDetails.filter((entry) => {
                    return entry.IsNationality;
                }).map(
                    (entry): CustomerTaxResidencyModel => {
                        return {
                            Country: entry.Country,
                            PrimaryCitizenship: entry.PrimaryCitizenship,
                            NationalIdentifier: entry.NationalIdentifier,
                            PassportNumber: entry.PassportNumber,
                            TaxExempt: entry.TaxExempt,
                            TaxExemptionReason: entry.TaxExemptionReason,
                            IsNationality: entry.IsNationality,
                            TaxReference: entry.TaxReference,
                        };
                    }
                );
                const residencies = CustomerTaxResidencyDetails.filter((entry) => {
                    return entry.IsTaxResident;
                }).map(
                    (entry): CustomerTaxResidencyModel => {
                        return {
                            Country: entry.Country,
                            IsTaxResident: entry.IsTaxResident,
                            PrimaryTaxResidency: entry.PrimaryTaxResidency,
                            TaxReferenceType: entry.TaxReferenceType,
                            TaxReference: entry.TaxReference,
                            TaxResidencyForPensionRelief: entry.TaxResidencyForPensionRelief,
                            TaxExempt: entry.TaxExempt,
                            TaxExemptionReason: entry.TaxExemptionReason,
                        };
                    }
                );
                if (this.state.residencies.length !== residencies.length) {
                    this.setState({
                        residencies: residencies.length > 0 ? residencies : [{ IsTaxResident: true }],
                        nationalities: nationalities,
                        // taxResidencyOtherThanUK: residencies.some((residency) => residency.Country !== CountryCode.GBR),
                    });
                }
                if (this.state.nationalities.length !== nationalities.length) {
                    this.setState({
                        nationalities: nationalities,
                    });
                }
            } else if (
                CustomerTaxResidencyDetails[0].TaxReference !== this.state.residencies?.[0]?.TaxReference &&
                this.state.residencies?.[0]?.Country == CountryCode.GBR
            ) {
                // NI number is always on the UK entry and this is always the first entry
                const { residencies } = this.state;
                const { nationalities } = this.state;
                residencies[0].TaxReference = CustomerTaxResidencyDetails[0].TaxReference;
                if (nationalities[0].Country === CountryCode.GBR) {
                    nationalities[0].TaxReference = CustomerTaxResidencyDetails[0].TaxReference;
                }
                this.setState({ residencies: residencies, nationalities: nationalities });
            }
        }
    }

    private checkDisableStatus() {
        if (this.props.disableWhenFullClient) {
            this.setState({
                disableTax: this.getBlockStatus(this.props.existingClientInfo) == EWizardLinterStatus.PleaseCheck,
            });
        }
        if (this.props.isAddNewProduct) {
            this.setState({
                disableTax: true,
            });
        }
    }

    getBlockStatus(data: FullClientDetailModel): EWizardLinterStatus {
        let complete =
            data?.EmploymentDetails?.IndividualEmploymentStatus != null &&
            data?.CustomerTaxResidencyDetails?.findIndex((x) => !this.validateCountry(x)) == -1;
        if (complete) {
            complete =
                data?.CustomerTaxResidencyDetails.some((x) => x.IsNationality == true) &&
                data?.CustomerTaxResidencyDetails.some((x) => x.IsTaxResident == true) &&
                data?.CustomerTaxResidencyDetails.some((x) => x.PrimaryCitizenship != null);
        }
        if (complete && this.state.taxResidencyOtherThanUK && data?.EmploymentDetails?.IsCrownEmployeeOrArmedForce == false) {
            complete = data?.CustomerTaxResidencyDetails.some(
                (x) =>
                    x?.Country != CountryCode.GBR &&
                    ((x?.IsTaxResident == true && !CommonHelper.isNullOrEmpty(x?.TaxReference)) ||
                        (x?.IsNationality && !CommonHelper.isNullOrEmpty(x?.PassportNumber)))
            );
        }
        if (complete) {
            complete =
                !CommonHelper.isNullOrEmpty(data?.PersonalDetails?.CountryOfBirth) &&
                !CommonHelper.isNullOrEmpty(data?.EmploymentDetails?.IndividualEmploymentStatus) &&
                !CommonHelper.isNullOrEmpty(data?.EmploymentDetails?.Occupation) &&
                !CommonHelper.isNullOrEmpty(data?.EmploymentDetails?.BusinessCategory) &&
                !CommonHelper.isNullOrEmpty(data?.EmploymentDetails?.SourceOfWealthPrimary?.SourceOfWealthOption) &&
                !CommonHelper.isNullOrEmpty(data?.EmploymentDetails?.CountryOfOriginPrimary);
        }
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    validateCountry(data: CustomerTaxResidencyModel): boolean {
        if (isEmpty(data)) {return true;}
        if (data?.Country != null && data?.Country == CountryCode.GBR) {
            return data?.IsTaxResident != null && data?.PrimaryTaxResidency != null;
        } else {
            if (data?.Country == null && (data?.PrimaryTaxResidency == null || data?.PrimaryCitizenship == null)) {
                return false;
            }
            if (data?.IsTaxResident && data?.IsTaxResident == true) {
                return data?.TaxReference != null;
            }
            if (data?.IsNationality && data?.IsNationality == true) {
                return (
                    !CommonHelper.isNullOrEmpty(data?.NationalIdentifier) ||
                    !CommonHelper.isNullOrEmpty(data?.PassportNumber)
                );
            }
        }
        return false;
    }

    private onNationalityChange(changes: CustomerTaxResidencyModel[]) {
        const { residencies } = this.state;
        changes.forEach((item) => {
            if (item.Country != CountryCode.GBR && item?.Country != null) {
                const tempResidency = residencies?.find((x) => x.Country == item.Country);
                if (!CommonHelper.isNullOrEmpty(tempResidency)) {
                    item.TaxReference = tempResidency?.TaxReference;
                }
            }
        });
        this.setState({ nationalities: changes }, this.updateCustomerTaxData);
    }

    private onResidencyChange(changes) {
        this.setState({ residencies: changes }, this.updateCustomerTaxData);
    }

    private updateCustomerTaxData() {
        const ctdChanges = this.state.residencies.filter((residency) => {
            return residency.Country || residency.Country == CountryCode.NotSpecified;
        });
        this.state.nationalities
            .filter((nationality) => {
                return nationality.Country != null;
            })
            .forEach((nationality) => {
                const existingResidencyIndex = ctdChanges.findIndex((residency) => {
                    return nationality.Country === residency.Country && nationality.Country != CountryCode.NotSpecified;
                });
                if (existingResidencyIndex > -1) {
                    ctdChanges[existingResidencyIndex] = {
                        ...ctdChanges[existingResidencyIndex],
                        ...nationality,
                        ...{ TaxReference: ctdChanges[existingResidencyIndex]?.TaxReference },
                    };
                } else {
                    ctdChanges.push(nationality);
                }
            });

        this.props.onCCMChange([{ value: ctdChanges, path: "CustomerTaxResidencyDetails" }]);
    }

    render() {
        const { data } = this.props;
        const { disableTax } = this.state;
        const employmentDetails = data.EmploymentDetails;

        return (
            <WizardLinter
                status={this.getBlockStatus(this.props.data)}
                enabled={this.props.disableHeader ? false : true}
            >
                {!this.props.disableHeader && SectionHeader("Regulatory details")}

                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Does your client hold tax residency status anywhere other than the UK?"}
                    selected={this.state.taxResidencyOtherThanUK}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    disabled={disableTax}
                    onChange={(v) => {
                        this.setState({ taxResidencyOtherThanUK: v });
                        if (!v) {
                            // Remove other residencies
                            const newResidencies = this.state.residencies.filter((residency) => {
                                return residency.Country === CountryCode.GBR;
                            });
                            this.onResidencyChange(newResidencies);
                        } else {
                            this.props.onCCMChange([
                                {
                                    value: this.props?.data?.EmploymentDetails?.IsCrownEmployeeOrArmedForce
                                        ? true
                                        : false,
                                    path: "EmploymentDetails.IsCrownEmployeeOrArmedForce",
                                },
                            ]);
                        }
                    }}
                />
                {this.state.taxResidencyOtherThanUK && (
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label={"Is your client, or your client's spouse a Crown employee?"}
                        selected={employmentDetails?.IsCrownEmployeeOrArmedForce}
                        required={"Please select"}
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        disabled={disableTax}
                        onChange={(v) => {
                            if (v) {
                                this.props.onCCMChange([
                                    { value: v, path: "EmploymentDetails.IsCrownEmployeeOrArmedForce" },
                                ]);
                                // Remove other residencies
                                const newResidencies = this.state.residencies.filter((residency) => {
                                    return residency.Country === CountryCode.GBR;
                                });
                                this.onResidencyChange(newResidencies);
                            } else {
                                this.props.onCCMChange([
                                    { value: v, path: "EmploymentDetails.IsCrownEmployeeOrArmedForce" },
                                ]);
                            }
                        }}
                    />
                )}
                {!employmentDetails?.IsCrownEmployeeOrArmedForce && this.state.taxResidencyOtherThanUK && (
                    <TaxResidency
                        data={this.state.residencies}
                        onChange={(v) => this.onResidencyChange(v)}
                        disableTax={disableTax}
                        onRef={(ref) => this.appendChild(ref)}
                        existingCustomer={this.props.existingCustomer}
                        taxResidencyOtherThanUK={this.state.taxResidencyOtherThanUK}
                    />
                )}

                <Nationality
                    data={this.state.nationalities}
                    onChange={(v) => {
                        this.onNationalityChange(v);
                    }}
                    disableTax={disableTax}
                    onRef={(ref) => this.appendChild(ref)}
                    residencies={this.state.residencies}
                />

                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    required={"Please select country of birth"}
                    onChange={(v) => {
                        this.props.onCCMChange([{ value: v, path: "PersonalDetails.CountryOfBirth" }]);
                    }}
                    label="Country of birth"
                    disabled={disableTax}
                    selected={data.PersonalDetails?.CountryOfBirth}
                />

                {!this.props.disableHeader && (
                    <SelectEditor
                        cssWrapper="control-size-430"
                        placeholder="Please select"
                        options={IndividualEmploymentStatusOptions}
                        getText={(v) => {
                            return IndividualEmploymentStatusOptionsMap[v];
                        }}
                        required={"Please select employment status"}
                        onChange={(v) =>
                            this.props.onCCMChange([{ value: v, path: "EmploymentDetails.IndividualEmploymentStatus" }])
                        }
                        label={"Employment status"}
                        disabled={disableTax}
                        selected={data.EmploymentDetails?.IndividualEmploymentStatus}
                    />
                )}

                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={EmploymentRole}
                    getText={(v) => v}
                    required={"Please select employment role"}
                    onChange={(v) => this.props.onCCMChange([{ value: v, path: "EmploymentDetails.Occupation" }])}
                    label={"Employment role"}
                    disabled={disableTax}
                    selected={data.EmploymentDetails?.Occupation}
                />

                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={OccupationIndustry}
                    getText={(v) => v}
                    required={"Please select occupation industry"}
                    onChange={(v) => {
                        this.props.onCCMChange([{ value: v, path: "EmploymentDetails.BusinessCategory" }]);
                    }}
                    label={"Occupation industry"}
                    disabled={disableTax}
                    selected={data?.EmploymentDetails?.BusinessCategory}
                />

                <SourceOfWealth
                    data={data}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.props.onCCMChange(changes);
                    }}
                    disableTax={disableTax}
                    onRef={(ref) => this.appendChild(ref)}
                />
            </WizardLinter>
        );
    }
}
